import React, { Component } from 'react';
import styles from './Footer.module.scss';
import Container from "../../hoc/Container/Container";
import { NavLink } from "react-router-dom";

import logo from '../../assets/footer/connatix-logo.svg';
import facebookLogo from '../../assets/footer/facebook.png';
import instagramLogo from '../../assets/footer/instagram.png';
import linkedinLogo from '../../assets/footer/linkedin.png';
import twitterLogo from '../../assets/footer/twitter.png';

class Footer extends Component {

  setHeaderMenuActive = (headerMenuCategory) => {
    const currentActiveItem = document.getElementsByClassName('menu-header-active')[0];
    if(currentActiveItem) {
      currentActiveItem.classList.remove('menu-header-active');
    }
    const newActiveItem =  document.getElementById(headerMenuCategory);
    if(newActiveItem) {
      newActiveItem.classList.add('menu-header-active');
    }
  };

  render() {
    return (
      <footer className={styles['footer']}>
          <Container>
            <div className={styles['footer-content']}>
              <div className={styles['footer-logos']}>
                <img src={logo}
                      className={styles['connatix-logo']}
                      alt="Connatix"/>
                <div className={styles['footer-menu__social']}>
                  <a href="https://www.linkedin.com/company/connatix"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles['footer-menu__link']}><img src={linkedinLogo} alt='Linkedin'/></a>
                  <a href="https://twitter.com/connatix"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles['footer-menu__link']}><img src={twitterLogo} alt='Twitter'/></a>
                    <a href="https://www.facebook.com/Connatix/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles['footer-menu__link']}><img src={facebookLogo} alt='Facebook'/></a>
                    <a href="https://www.instagram.com/connatix"
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles['footer-menu__link']}><img src={instagramLogo} alt='Instagram'/></a>
                </div>
              </div>
              <div className={styles['footer-middle']}>
                <div className={styles['footer-text']}>
                  <div className={styles['footer-title']}>Video. Reimagined.</div>
                  <div className={styles['footer-description']}>Deliver successful video experiences without compromise.</div>              
                </div>
                <div className={styles['footer-menu']}>
                  <nav className={styles['footer-menu__navigation']}>
                    <ul className={styles['footer-menu__section']}>
                      <li className={styles['footer-menu__section__title']}>Publishers</li>
                      <li onClick={() => this.setHeaderMenuActive("Publishers")}><NavLink to="/elements" className={styles['footer-menu__link']}>Elements</NavLink></li>
                      <li onClick={() => this.setHeaderMenuActive("Publishers")}><NavLink to="/playspace" className={styles['footer-menu__link']}>Playspace</NavLink></li>
                      <li onClick={() => this.setHeaderMenuActive("Publishers")}><NavLink to="/adserver" className={styles['footer-menu__link']}>Ad Server</NavLink></li>
                      <li onClick={() => this.setHeaderMenuActive("Publishers")}><NavLink to="/automatedcontent" className={styles['footer-menu__link']}>Automated Content Generation</NavLink></li>
                      <li className={styles['footer-menu__section__title']} onClick={() => this.setHeaderMenuActive("Advertisers")}>
                        <NavLink className={styles['footer-menu__section__title']} to="/advertisers">Advertisers</NavLink>
                      </li>
                    </ul>
                    <ul className={styles['footer-menu__section']}>
                      <li className={styles['footer-menu__section__title']}>News & Views</li>
                      <li onClick={() => this.setHeaderMenuActive("News & Views")}><NavLink to="/blog" className={styles['footer-menu__link']}>Blog</NavLink></li>
                      <li onClick={() => this.setHeaderMenuActive("News & Views")}><NavLink to="/press" className={styles['footer-menu__link']}>Press</NavLink></li>
                      {/* <li onClick={() => this.setHeaderMenuActive("News & Views")}><NavLink to="/events" className={styles['footer-menu__link']}>Events</NavLink></li> */}
                    </ul>
                    <ul className={styles['footer-menu__section']}>
                      <li className={styles['footer-menu__section__title']}>About Us</li>
                      <li onClick={() => this.setHeaderMenuActive("About Us")}><NavLink to="/who-we-are" className={styles['footer-menu__link']}>Who we are</NavLink></li>
                      <li onClick={() => this.setHeaderMenuActive("About Us")}><NavLink to="/leadership" className={styles['footer-menu__link']}>Leadership</NavLink></li>
                      <li onClick={() => this.setHeaderMenuActive("About Us")}><NavLink to="/careers" className={styles['footer-menu__link']}>Careers</NavLink></li>
                      <li onClick={() => this.setHeaderMenuActive("About Us")}><NavLink to="/contact" className={styles['footer-menu__link']}>Contact us</NavLink></li>
                    </ul>
                    <ul className={styles['footer-menu__section']}>
                      <li className={styles['footer-menu__section__title']}>Information</li>
                      <li>
                        <a href="https://support.connatix.com/hc/en-us"
                        rel="noreferrer noopener"
                        target="_blank"
                        className={styles['footer-menu__link']}>Developer support
                        </a>
                      </li>
                      <li>
                        <a href="https://portal.connatix.com/login"
                          rel="noreferrer noopener"
                          target="_blank"
                          className={styles['footer-menu__link']}>Platform login
                        </a>
                      </li>
                      <li onClick={() => this.setHeaderMenuActive("About Us")}><NavLink to="/privacy-policy" className={styles['footer-menu__link']}>Privacy</NavLink></li>
                    </ul>
                  </nav>
                </div>            
              </div>

              <div className={styles['footer__copyright']}>&copy; {new Date().getFullYear()} Connatix Holdings Inc., All Rights Reserved.</div>
            </div>
          </Container>
      </footer>
    )
  }
}

export default Footer;